import { render } from "./branch-move.vue?vue&type=template&id=08f78122"
import script from "./branch-move.vue?vue&type=script&lang=js"
export * from "./branch-move.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__